import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {useSuiteHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Suspense} from 'react'
import {Navigate, Outlet, RouteObject} from 'react-router'

import {
  AnalysisDetailPage,
  AnalysisListPage,
  CreateAnalysisPage,
  PlantUpmIdAdapter
} from '../components'
import {rcfaListFeatureTranslations} from '../localization'

import {RcfaBaseRoutes} from './routes'

const RoutesWrapper = ({children}: {children: React.ReactNode}) => {
  const plantUpmId = useSuiteHierarchyId()

  if (!plantUpmId) {
    throw new Error('Hierarchy id is required in RcfaListRoutes')
  }

  return (
    <ThemeProvider theme={useFundamentalMuiTheme()}>
      <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <PlantUpmIdAdapter plantUpmId={plantUpmId}>{children}</PlantUpmIdAdapter>
        </LocalizationProvider>
      </Suspense>
    </ThemeProvider>
  )
}

export const rcfaListRoutes: RouteObject = {
  path: '*',
  element: (
    <FeatureTranslationsLoader translations={rcfaListFeatureTranslations}>
      <RoutesWrapper>
        <Outlet />
      </RoutesWrapper>
    </FeatureTranslationsLoader>
  ),
  children: [
    {
      index: true,
      element: <Navigate to={RcfaBaseRoutes.analysisList} replace />
    },
    {
      path: RcfaBaseRoutes.analysisList,
      element: <AnalysisListPage />
    },
    {
      path: RcfaBaseRoutes.graphDetail,
      element: <AnalysisDetailPage />
    },
    {
      path: RcfaBaseRoutes.newAnalysis,
      element: <CreateAnalysisPage />
    },
    {path: '*', element: <Navigate to="/404" replace />}
  ]
}
